import gql from 'graphql-tag';

export const getPotentialSellers = gql`
query getPotentialSellers(
    $input: GetPotentialSellerIdInput) {
      getPotentialSellers(getPotentialSellerIdInput: $input) {
        potentialSellers {
          id
          name
          lastName
        }
      }
    }
`;

export const getSimulatedPotentialSellers = gql`
query getSimulatedPotentialSellers(
    $input: GetSimulatedPotentialSellersInput) {
      getSimulatedPotentialSellers(getSimulatedPotentialSellersInput: $input) {
        potentialSellers {
          id
          name
          lastName
        }
      }
    }
`;

export const getPotentialSellersCount = gql`
query getPotentialSellersCount(
    $input: GetPotentialSellerInput) {
      getPotentialSellersCount(getPotentialSellerInput: $input) {
        leads {
          leadId
          potentialSellersCount
        }
      }
    }
`;
